import React from 'react';
import ReactDOM from 'react-dom/client';
import html2canvas from 'html2canvas';
import './index.css';
import App from './App';

window.html2canvas = html2canvas;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
